import Model from 'flarum/common/Model';
import User from 'flarum/common/models/User';

// Names must match the PHP serializer attributes exactly (CLAUDE.md 7.6).
export default function extendUser() {
  User.prototype.uinfoKids = Model.attribute('uinfoKids');
  User.prototype.uinfoCanView = Model.attribute('uinfoCanView');
  User.prototype.uinfoShowOnProfile = Model.attribute('uinfoShowOnProfile');
  User.prototype.uinfoShowOnPosts = Model.attribute('uinfoShowOnPosts');

  // Owner-only mirrors of the stored preferences, used by the settings page.
  User.prototype.uinfoShowOnProfilePref = Model.attribute('uinfoShowOnProfilePref');
  User.prototype.uinfoShowOnPostsPref = Model.attribute('uinfoShowOnPostsPref');
  User.prototype.uinfoDisplayMode = Model.attribute('uinfoDisplayMode');
}
